"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayStatus = exports.LongRunningTaskManagerState = exports.LongRunningTaskManagerService = exports.LongRunningTaskManager = void 0;
exports.getLongRunningTaskManager = getLongRunningTaskManager;
const long_running_task_manager_1 = require("./long.running.task.manager");
var long_running_task_manager_2 = require("./long.running.task.manager");
Object.defineProperty(exports, "LongRunningTaskManager", { enumerable: true, get: function () { return long_running_task_manager_2.LongRunningTaskManager; } });
var long_running_task_manager_service_1 = require("./long.running.task.manager.service");
Object.defineProperty(exports, "LongRunningTaskManagerService", { enumerable: true, get: function () { return long_running_task_manager_service_1.LongRunningTaskManagerService; } });
var long_running_task_manager_state_1 = require("./long.running.task.manager.state");
Object.defineProperty(exports, "LongRunningTaskManagerState", { enumerable: true, get: function () { return long_running_task_manager_state_1.LongRunningTaskManagerState; } });
Object.defineProperty(exports, "getDisplayStatus", { enumerable: true, get: function () { return long_running_task_manager_state_1.getDisplayStatus; } });
/**
 * Lazy singleton to avoid circular dependency with Services.
 * LongRunningTaskManager imports Services, so it cannot be instantiated
 * inside the ServiceRegistry constructor.
 */
let _instance = null;
function getLongRunningTaskManager() {
    if (_instance == null) {
        _instance = new long_running_task_manager_1.LongRunningTaskManager();
    }
    return _instance;
}
//# sourceMappingURL=index.js.map